import React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
const tooltip = ({ ContentText }) => <Tooltip>{ContentText}</Tooltip>;
export function TooltipBootrap(props) {
  let { contentText, trigger, placement, children } = props;
  return (
    <OverlayTrigger
      trigger={trigger}
      placement={placement}
      overlay={tooltip({ ContentText: contentText })}
    >
      {children}
    </OverlayTrigger>
  );
}
